import tw from 'twin.macro';

export { ThemeContext } from './Context';
export { default as ThemeProvider } from './Provider';

export const fsbgimg = tw`absolute inset-0 z-0 bg-cover bg-center`;

export const roundedImg = tw`rounded-lg`;
